import Spinner from '@atlaskit/spinner';

export type { Size, Appearance, SpinnerProps } from '@atlaskit/spinner';
export default Spinner;
